import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { NavTopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { PURCHASE_ORDERS_LIST_CONTROLS_VIEW } from "@constants/storage"

import PurchaseOrderCardsView from "./views/PurchaseOrderCardsView/PurchaseOrderCardsView"
import PurchaseOrderTableView from "./views/PurchaseOrderTableView/PurchaseOrderTableView"

export default function PurchaseOrderList() {
    const [createRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="purchase-order-list">
            <ViewTypesProvider
                viewTypes={["table", "cards"]}
                viewTypeKey={PURCHASE_ORDERS_LIST_CONTROLS_VIEW}
                defaultViewType="table"
            >
                {({ activeViewType }) => (
                    <>
                        <NavTopBar.Root>
                            <NavTopBar.Header>
                                <NavTopBar.NavTopBarHeaderStart>
                                    <NavTopBar.PageTitle
                                        label={objectMap.purchase_order.labelPlural}
                                        icon={objectMap.purchase_order.iconActive}
                                    />
                                </NavTopBar.NavTopBarHeaderStart>
                                <NavTopBar.NavTopBarHeaderEnd>
                                    <NavTopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            purchase_orders_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                purchase_orders_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <NavTopBar.SearchButton scope="Purchase orders" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <AccessCheck
                                        permissions={{
                                            purchase_orders_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <NavTopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </NavTopBar.NavTopBarHeaderEnd>
                            </NavTopBar.Header>
                        </NavTopBar.Root>
                        {activeViewType === "cards" ? <PurchaseOrderCardsView /> : <PurchaseOrderTableView />}
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
